import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function _2kIcon(props: IconProps) {
    return <Icon {...props} iconKey={"2k"}/>
}
